import { Form, Loading } from 'antd-mobile'
import dayjs from 'dayjs'
import { toJS } from 'mobx'
import { observer, useLocalObservable } from 'mobx-react-lite'
import React, { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import NewEditForm from '@/components/NewEditForm'
import { StatusCode } from '@/components/NewEditForm/enum'
import useCommonForm from '@/components/NewEditForm/hooks/useCommonForm'
import { certificateFromData } from '@/components/NewEditForm/UILibrary/HYBElement/BlockLevel/BlockLevelForm/utils'
import { DATEPICKER_MIN_DEFAULT_TIMESTAMP } from '@/constants'
import jobStore from '@/store/components/entryJob'
import { getUrlParams } from '@/utils'

import HPopup from '../../HYBVant/HPopup'

import { hrmSaveEducation, hrmEducationList, hrmDeleteEducation } from './service'

import './index.less'

const Education: React.FC<any> = ({ visible, onCancel, modalData }) => {
  const [formIt] = Form.useForm()
  const currentFiledsRef: any = useRef(null)
  const location = useLocation()

  const {
    changeEducation,
    education,
    employeeIds,
    educationStatus,
    changeAllEducation,
    cacheEducationJson,
    changeCacheEducationJson
  } = useLocalObservable(() => jobStore)
  const { id } = getUrlParams()
  const isNoAuth = ['/entry/fast'].includes(location.pathname)
  const qrcodeId = isNoAuth ? id : ''
  const vars = {
    minDate: DATEPICKER_MIN_DEFAULT_TIMESTAMP
  }
  const { option, optionStatus } = useCommonForm({
    code: 'educational_experience_from',
    immediate: !qrcodeId,
    vars
  })

  const onFinish = async (fieldValues: any) => {
    const attachments = certificateFromData(fieldValues?.attachments || [])
    const start_date_old = fieldValues?.education_date?.[0] || fieldValues?.start_date
    const start_date = start_date_old ? dayjs(start_date_old).format('YYYY-MM-DD') : ''
    const end_date_old = fieldValues?.education_date?.[1] || fieldValues?.end_date
    const end_date = end_date_old ? dayjs(end_date_old).format('YYYY-MM-DD') : ''
    const field = {
      ...(currentFiledsRef.current || {}),
      ...fieldValues,
      attachments,
      employee_id: employeeIds?.[0],
      start_date,
      end_date
      // education_name: store.getOptions('HRM_EDUCATION_LEVEL')?.find(x => x.value === fieldValues?.education_level)?.name
    }
    await hrmSaveEducation(field)
    fetchHrmEducationList()
  }

  const fetchHrmEducationList = async () => {
    const { code, data } = await hrmEducationList({ employee_id: employeeIds?.[0] })
    if (code === 2000) {
      changeAllEducation(data)
      onCancel()
    }
  }

  useEffect(() => {
    const setFieldValues = () => {
      const fields = education.find((x) => x.active)
      const attachment = fields?.attachment?.map((x: any) => x?.oss_key || x) || []
      const start_date_old = fields?.education_date?.[0] || fields?.start_date
      const end_date_old = fields?.education_date?.[1] || fields?.end_date
      fields.education_date = start_date_old && end_date_old ? [start_date_old, end_date_old] : []
      currentFiledsRef.current = fields
      formIt.setFieldsValue({
        ...fields,
        attachment
      })
    }
    educationStatus === 'Edit' && option?.formInfo?.length && setFieldValues()
  }, [educationStatus, option])

  const deleteInfo = async () => {
    console.log('education:', toJS(education))
    await hrmDeleteEducation([education.find((x) => x.active)?.id])
    fetchHrmEducationList()
  }

  const getFormButtons = (hasDelete?: boolean) => {
    const btns = [
      {
        key: 'remove',
        title: '删除',
        className: 'delete-btn',
        onClick: deleteInfo
      },
      {
        key: 'submit',
        title: '保存'
      }
    ]
    return hasDelete ? btns : btns.slice(1)
  }

  useEffect(() => {
    if (Array.isArray(option?.formInfo) && optionStatus === StatusCode.done) {
      changeCacheEducationJson(option.formInfo)
    }
  }, [option, optionStatus])

  console.log('formInfo111', qrcodeId, toJS(education), toJS(cacheEducationJson), educationStatus)
  return (
    <HPopup title='教育经历' hasOk={false} className='lg' visible={visible} onCancel={onCancel}>
      {Array.isArray(cacheEducationJson) || optionStatus === StatusCode.done ? (
        <NewEditForm
          formInst={formIt}
          formInfo={cacheEducationJson ?? option.formInfo ?? []}
          onFinish={onFinish}
          formButtons={getFormButtons(modalData?.status === 'Edit')}
        />
      ) : (
        <Loading className='init-loading lg' />
      )}
    </HPopup>
  )
}

export default observer(Education)
